Ext.namespace('utils.config');

utils.config = (function( $, Ext, window, undefined ){
    var public = {};
	
	public.grid = {
		column: function (header, dataIndex, width, renderer, align, sortable, css, _config){
			var config = {};
			
			switch(header) 
			{ 
				case 'RowNumberer': 
					config = new Ext.grid.RowNumberer({
						align : "center",
						css   : 'vertical-align:middle;'
					});
				break; 
				
				case 'CheckboxSelectionModel': 
					config = new Ext.grid.CheckboxSelectionModel ({
						singleSelect : false,
						align        : "center",
						css          : 'vertical-align:middle;'
					});
				break; 
				
				default: 
					config.header    = header;
					config.dataIndex = dataIndex;
					config.align     = align ? align : "center";
					config.css       = css ? css : 'vertical-align:middle;';
					config.sortable  = sortable ? true : false;
	
					if(renderer) config.renderer = renderer;
					if(width) config.width = width;
					if(_config) Ext.apply(config, _config); 
			}
			
			return config;
		}
	};
		
	public.form = {
		combo: function(name, fieldLabel, data, fun, width, emptyText, id){
			var config = {};
	
			config.xtype = "combo";
			config.editable = false;
			config.displayField = 'value';
			config.valueField = 'id';
			config.triggerAction = 'all';
			config.value = '';
			config.mode = 'local';  
			config.autoSelect = true;  
			config.selectOnFocus = true;  
			
			if(fun) config.listeners = {select: fun};
			if(fieldLabel) config.fieldLabel = fieldLabel; 
			if(emptyText) config.emptyText = emptyText; 
			if(id) config.id = id; 
			
			config.hiddenName = name;
			config.store = (typeof data === 'string' ? utils.jsonStore(data) : data);
			config.width = width ? width : 100; 
	
			return config;
		},
		required: function (el){
			var config = {};
	
			if(el.attr('required')) 
			{
				var error = el.closest("td").next("td").find(".error-msg")[0];
				
				config.allowBlank = false;
				
				if(error) config.msgTarget = error;
			}
	
			return config;
		}
	};
	    
    return public;
}( jQuery, Ext, window ));


